import { useChatId } from '../../../contexts';

/**
 * Hook for managing chat selection and navigation
 * Handles chat selection and routing to chat history
 */
export const useChatNavigation = (locale: string = 'en') => {
  const { setChatId } = useChatId();

  const handleChatHistoryClick = () => {
    // Extensions do not have Next.js routing. Clearing selection returns the UI
    // to the start screen within the current surface.
    setChatId(null);
  };

  const handleSelectChat = (chatId: string) => {
    setChatId(chatId);
  };

  return {
    handleChatHistoryClick,
    handleSelectChat,
  };
};
